import { IconFeather } from '@tabler/icons-react';

import { useState } from 'react';

import { ActionIcon, Tooltip } from '@mantine/core';

import { DocumentChatDrawer } from '../chat/DocumentChatDrawer';

export default function ToolbarChatButton({ getCurrentMarkdown }: { getCurrentMarkdown: () => string }) {
    const [chatOpened, setChatOpened] = useState(false);
    const [snapshotContent, setSnapshotContent] = useState('');

    const handleOpen = () => {
        setSnapshotContent(getCurrentMarkdown());
        setChatOpened(true);
    };

    return (
        <>
            <Tooltip label='Open AI Assistant' position='bottom'>
                <ActionIcon
                    variant='subtle'
                    size='lg'
                    color='gray'
                    style={{ color: 'var(--mantine-color-text)' }}
                    onClick={handleOpen}
                >
                    <IconFeather size={20} />
                </ActionIcon>
            </Tooltip>

            <DocumentChatDrawer
                opened={chatOpened}
                onClose={() => setChatOpened(false)}
                documentContent={snapshotContent}
            />
        </>
    );
}
